const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bomb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M35,70a35.47,35.47,0,0,1-8.45-1A35,35,0,1,1,49.83,3.3c3.53-2.25,8.75-.54,12.39,4.16.15.19.3.39.44.59a11.89,11.89,0,0,1,3.61,2.31,10.6,10.6,0,0,1,3.27,7.91A9,9,0,0,1,68,23.44a32.32,32.32,0,0,1,1.14,4h0A35,35,0,0,1,35,70ZM35,6.47A28.57,28.57,0,1,0,62.85,28.84h0A27.53,27.53,0,0,0,61.34,24a3.17,3.17,0,0,1-.16-2,3.2,3.2,0,0,1-1.49-1.33c-.29-.5-.6-1-.92-1.48a3.23,3.23,0,0,1-.11-3.39.92.92,0,0,0,.06-.29,3.33,3.33,0,0,1,.77-1.79,3.16,3.16,0,0,1-1.73-1.4,11.43,11.43,0,0,0-.65-.95c-1.59-2-3.35-2.68-3.87-2.62A1.81,1.81,0,0,1,53,9l-1.37.79a3.22,3.22,0,0,1-3.14.06A28.47,28.47,0,0,0,35,6.47Z",
    style: {
      fill: "#051d27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.76,35A31.62,31.62,0,0,0,66,28.14c-2.45-.61-13.43-3.53-16.07-3.53-17.55,0-28.75,14.48-28.75,32,0,2.35,5.65,7,6.14,9.19A31.8,31.8,0,0,0,66.76,35Z",
    style: {
      fill: "#d8003e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.34,27.2a31.72,31.72,0,0,1,7.67.94A31.76,31.76,0,1,0,27.33,65.83a31.77,31.77,0,0,1,31-38.63Z",
    style: {
      fill: "#fd013e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.33,6.19,45.71,9.44c-2.24,1.74-1.7,6.17,1.19,9.9S54,24.69,56.19,23l4.55-4.64Z",
    style: {
      fill: "#d8003e"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.03,
    cy: 12.26,
    rx: 4.6,
    ry: 7.67,
    transform: "translate(4.24 36.9) rotate(-37.78)",
    style: {
      fill: "#fd013e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.45,38.53a1.55,1.55,0,0,1-.37,0,1.84,1.84,0,0,1-1.44-2.17c2-9.64,10.07-12,16-13.71,4.86-1.41,7-2.24,7-4.34a3.76,3.76,0,0,0-1.11-2.89c-1.91-1.81-5.63-1.67-5.67-1.66a1.84,1.84,0,1,1-.2-3.68c.22,0,5.33-.25,8.41,2.67a7.43,7.43,0,0,1,2.26,5.56c0,5.08-4.9,6.5-9.65,7.88-5.85,1.69-11.9,3.45-13.41,10.9A1.85,1.85,0,0,1,41.45,38.53Z",
    style: {
      fill: "#2a2f3c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.81 53.29 33.53 54.59 30.13 56.91 30.49 53.72 32.81 53.29",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.47 56.89 20.73 57.24 19.67 57.76 19.72 56.95 20.47 56.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.15 47.91 32.26 48.82 33.05 48.66 32.87 47.59 32.15 47.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.28 46.02 34.89 47.73 36.14 47.94 36.82 46.87 36.39 45.91 35.28 46.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.02 48.47 37.97 49.28 39.03 48.76 38.77 48.41 38.02 48.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.13 49.33 42.21 48.85 42.71 50.93 41.48 51.1 41.13 49.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.64 39.9 33.07 40.85 32.39 41.92 31.14 41.71 31.54 40 32.64 39.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.43 45.41 44.62 46.48 43.83 46.65 43.71 45.74 44.43 45.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.56 43.79 46.62 45.17 49.51 46.55 49.95 45.02 47.56 43.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.47 47.67 52.42 48.48 53.48 47.96 53.22 47.61 52.47 47.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.74 51.27 51.31 52.23 52.6 53.19 54.63 51.91 51.74 51.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.63 58.46 50.91 58.78 51.02 59.69 51.82 59.53 51.63 58.46",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.62 39.13 46.86 36.72 48.76 36.45 49.38 37.45 46.62 39.13",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.89 33.9 61.84 34.71 62.9 34.19 62.64 33.84 61.89 33.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.15 33.15 47.73 33.71 47.01 34.52 46.57 33.86 47.15 33.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.75 33.83 35.69 34.34 35.73 33.53 36.48 33.47 36.75 33.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.78 37.44 35.05 37.77 35.17 38.67 35.96 38.51 35.78 37.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.78 34.62 33 35.77 31.73 35.41 31.25 33.9 32.46 32.87 33.78 34.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "28.58 24.4 28.76 25.46 27.97 25.63 27.85 24.72 28.58 24.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47 26.82 43.8 40.43 34.23 26.82 41.68 41.48 31.04 38.34 37.42 42.53 19.33 47.76 39.55 44.62 36.36 55.09 42.74 47.76 47 51.95 47 46.72 61.89 49.86 48.06 43.57 55.51 38.34 47 41.48 47 26.82",
    style: {
      fill: "#fdcb02"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.57 43.61 63.67 41.84 63.67 43.61 56.57 43.61",
    style: {
      fill: "#fdcb02"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.63 33.01 26.43 22.4 25.54 25.05 32.63 33.01",
    style: {
      fill: "#fdcb02"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.41 52.44 28.2 63.04 27.31 60.39 34.41 52.44",
    style: {
      fill: "#fdcb02"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.93 44.58 52.19 51.23 44.6 47 42.26 52.44 41.09 48.21 33.1 50.41 38.17 44.58 32.92 42.16 38.17 40.35 36.42 37.94 41.09 38.54 39.92 29.47 43.43 38.54 44.6 37.94 44.6 39.75 49.85 37.33 46.93 42.16 53.36 42.77 46.93 44.58",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMine);
export default __webpack_public_path__ + "static/media/mine.307667a5dc8589011d32c68096f5e231.svg";
export { ForwardRef as ReactComponent };